function storageKey(tplId) {
    return `ww_web_bonus_words.v1.${String(tplId || "").trim()}`;
}

function normalizeList(words) {
    const out = [];
    const seen = new Set();
    (Array.isArray(words) ? words : []).forEach((raw) => {
        const word = String(raw || "").trim().toUpperCase();
        if (!word || seen.has(word)) return;
        seen.add(word);
        out.push(word);
    });
    return out;
}

export function parseBonusWordsFromPlay(play) {
    const details = play?.details;
    if (!details || typeof details !== "object") return [];
    return normalizeList(details.bonusWords);
}

export function loadStoredBonusWords(tplId) {
    if (!tplId) return [];
    try {
        const raw = localStorage.getItem(storageKey(tplId));
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return normalizeList(parsed);
        return normalizeList(parsed?.words);
    } catch {
        return [];
    }
}

export function saveStoredBonusWords(tplId, words) {
    if (!tplId) return;
    try {
        localStorage.setItem(storageKey(tplId), JSON.stringify({ words: normalizeList(words) }));
    } catch {
        /* ignore quota */
    }
}

export function mergeBonusWordLists(...lists) {
    return normalizeList(lists.flatMap((list) => (Array.isArray(list) ? list : [])));
}
